import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from './utils';
import api from 'api';
import store from 'store';


const TAG_FILTER_UPDATE = 'update_filters';

const GET_FILTERS = '/filters';
const CREATE_FILTER = GET_FILTERS;
const GET_PIN_FILTERS = `${GET_FILTERS}/pins`;
const GET_AUTH_FILTER_TYPE = `${GET_FILTERS}/available_type`;
const POST_FILE_IMPORT_URL = `${GET_FILTERS}/import`;
const DELETE_FILTERS = `${GET_FILTERS}/delete`;
const FILTER_DETAIL = `${GET_FILTERS}/`;


const rtkOnlySuccUpdateTag = (succTag) => (result, error) => {
    if (error) {
        return [];
    }
    else {
        return succTag;
    }
};

export const filterApi = createApi({
    reducerPath: 'filterApi',
    baseQuery: baseQueryWithReauth,
    tagTypes: [TAG_FILTER_UPDATE],
    endpoints: builder => ({
        getAuthFilterType: builder.query({
            query: () => GET_AUTH_FILTER_TYPE,
        }),
        getFilterList: builder.query({
            query: ({ params }) => ({
                url: GET_FILTERS,
                params
            }),
            transformResponse: (response) => {
                const { update_time, ...data } = response;
                return ({
                    ...data,
                    updatedTime: update_time ?? Date.now(),
                });
            },
            providesTags: [TAG_FILTER_UPDATE]
        }),
        filterImport: builder.mutation({
            queryFn: async (file, _queryApi, _extraOptions, fetchWithBQ) => {
                const formData = new FormData();
                formData.append('file', file);
                try {
                    const resp = await store.dispatch(api.importFileByPOST({
                        url: POST_FILE_IMPORT_URL,
                        file: formData,
                    }));
                    return {
                        data: {
                            status: resp?.status,
                            data: resp?.data,
                        },
                    };
                } catch (err) {
                    return {
                        error: {
                            status: err.response?.status,
                            data: err.response?.data,
                        },
                    };
                }
            },
            invalidatesTags: rtkOnlySuccUpdateTag([TAG_FILTER_UPDATE])
        }),
        deleteFilters: builder.mutation({
            query: (filterIds) => ({
                url: DELETE_FILTERS,
                method: 'POST',
                body: filterIds,
            }),
            invalidatesTags: rtkOnlySuccUpdateTag([TAG_FILTER_UPDATE])
        }),
        createFilter: builder.mutation({
            query: ({ params }) => ({
                url: CREATE_FILTER,
                method: 'POST',
                body: params,
            }),
            invalidatesTags: rtkOnlySuccUpdateTag([TAG_FILTER_UPDATE])
        }),
        getPinnedFilters: builder.query({
            query: () => GET_PIN_FILTERS,
            providesTags: [TAG_FILTER_UPDATE],
        }),
        getFilterDetail: builder.query({
            query: (id) => ({
                url: `${ FILTER_DETAIL }${ id }`,
            }),
            transformResponse: (response) => {
                const { update_time, ...data } = response;
                return ({
                    ...data,
                    updatedTime: update_time ?? Date.now(),
                });
            },
        }),
        updateFilterDetail: builder.mutation({
            query: ({ params: { id, ...payload} }) => ({
                url: `${ FILTER_DETAIL }${ id }`,
                method: 'PATCH',
                body: payload,
            }),
            invalidatesTags: rtkOnlySuccUpdateTag([TAG_FILTER_UPDATE])
        }),
    })
});


export const {
    useGetAuthFilterTypeQuery,
    useGetFilterListQuery,
    useFilterImportMutation,
    useDeleteFiltersMutation,
    useCreateFilterMutation,
    useGetPinnedFiltersQuery,
    useGetFilterDetailQuery,
    useUpdateFilterDetailMutation,
} = filterApi;
